<template>
  <div id="mntCategory">
    <div v-if="$route.path == '/storemnt/mntcategory'" style="width: 100%;height:100% ">
      <category-tree @addcheck-treedata="getTreeCheckDataCategory" :categoryData="categoryData"
                     :checkCategoryId="parentId"
                     :oneNodeArr="categoryOpenArr"
                     :categoryTreeData="categoryTreeData"
                     labelName="categoryMemo"
      >
      </category-tree>
      <div class="right">
        <div class="operation">
          <div class="operationBtn">
            <el-dropdown trigger="click">
              <el-button :disabled="batchDisabled">{{$t('LanguageLib.BATCH_SET')}}</el-button>
              <el-dropdown-menu slot="dropdown" size="medium">
                <el-dropdown-item :title="$t('LanguageLib.STACK_SHELVES')" @click.native.prevent="batchStackCategory">
                  {{$t('LanguageLib.STACK_SHELVES')}}
                </el-dropdown-item>
                <el-dropdown-item :title="$t('LanguageLib.WITHDRAW_SHELVES')"
                                  @click.native.prevent="batchWithdrawCategory">
                  {{$t('LanguageLib.WITHDRAW_SHELVES')}}
                </el-dropdown-item>
                <el-dropdown-item :title="$t('LanguageLib.DELETE')" @click.native.prevent="batchDeleteCategory">
                  {{$t('LanguageLib.DELETE')}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" @click="addCategory" :disabled="currentClass==='third'?true:false">
              {{$t('LanguageLib.ADD_TO')}}
            </el-button>
<!--            <el-dropdown trigger="click">-->
<!--              <el-button type="primary">{{$t('LanguageLib.ImportOrExport')}}</el-button>-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item :title="$t('LanguageLib.DOWNLOAD_TEMPLATE')" @click.native.prevent="downloadExcel">-->
<!--                  {{$t('LanguageLib.DOWNLOAD_TEMPLATE')}}-->
<!--                </el-dropdown-item>-->
<!--                <el-dropdown-item :title="$t('LanguageLib.CLICK_UPLOAD')">-->
<!--                </el-dropdown-item>-->
<!--                <el-dropdown-item :title="$t('LanguageLib.EXPORT_EXCEL')" @click.native.prevent="exportExcel">-->
<!--                  {{$t('LanguageLib.EXPORT_EXCEL')}}-->
<!--                </el-dropdown-item>-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
          </div>
          <div class="operationSearch">
            <div class="showWithdraw">
              <el-checkbox v-model="showDisabled" style="margin-right: 6px"
                           @change="onShowWithDrawChange"></el-checkbox>
              {{$t('LanguageLib.SHOW_HAS_BEEN_WITHDRAWED_CATEGORY')}}
            </div>
            <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span
              class="colorG"> &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
            <i v-show="isSearch" @click="clearSearchData" class="el-icon-close"
               style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
            <el-input
              prefix-icon="el-icon-search"
              v-model="searchText"
              @keyup.enter.native="searchCategoryList"
            >
            </el-input>
          </div>
        </div>
        <div class="tableParent">
          <el-table
            empty-text=" "
            class="table-fixed"
            :data="tableData"
            stripe
            @selection-change="selectionChange"
            @sort-change='sortChange'
            :default-sort="defaultSort"
            ref="table"
            style="width: auto;"
            v-loading="loading"
            height="100%">
            <!--勾选框-->
            <el-table-column
              type="selection"
              width="45">
            </el-table-column>

            <!--序号-->
            <el-table-column
              prop="CategoryCode"
              :label="$t('LanguageLib.SERIAL_NUMBER')"
              sortable="custom"
              min-width="100">
              <template slot-scope="scope">
                {{scope.row.categoryCode}}
              </template>
            </el-table-column>

            <!--分类名-->
            <el-table-column
              prop="CategoryMemo"
              :label="$t('LanguageLib.CLASSIFICATION_NAME')"
              sortable="custom"
              min-width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content">{{scope.row.categoryMemo}}</span>
                  <span ref="toolTipItem"
                        style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                  >{{scope.row.categoryMemo}}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!--是否上架-->
            <el-table-column
              prop="IsEnable"
              :label="$t('LanguageLib.IS_STACK')"
              sortable="custom"
              min-width="150">
              <template slot-scope="scope">
                {{scope.row.isEnable===true?$t('LanguageLib.YES'):$t('LanguageLib.NO')}}
              </template>
            </el-table-column>

            <!--维修故障分类-->
            <el-table-column
              prop="problemCategoryList"
              :label="$t('LanguageLib.MNT_QUESTION_CATEGORY')"
              min-width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content">{{scope.row.problemCategoryList===null?'':listToString(scope.row.problemCategoryList)}}</span>
                  <span ref="toolTipItem"
                        style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                  >{{scope.row.problemCategoryList===null?'':listToString(scope.row.problemCategoryList)}}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!--默认供应商-->
            <el-table-column
              prop="vendorName"
              :label="$t('LanguageLib.DEFAULT_VENDOR')"
              sortable="custom"
              min-width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" v-html="scope.row.vendorName"></span>
                  <span ref="toolTipItem"
                        style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                        v-html="scope.row.vendorName"></span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!--          默认优先级-->
            <el-table-column
              prop="defaultPriorityName"
              :label="$t('LanguageLib.DEFAULT_PRIORITY')"
              min-width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content">{{scope.row.defaultPriorityName}}</span>
                  <span ref="toolTipItem"
                        style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                  >{{scope.row.defaultPriorityName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              fixed="right"
              :label="$t('LanguageLib.Operation')"
              min-width="120">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="editCategory(scope.row, scope.$index, tableData)"
                  :title="$t('LanguageLib.Edit')"
                  type="text"
                  style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                  <i class="iconfont">&#xe60c;</i>
                </el-button>
                <el-button
                  @click.native.prevent="deleteCategory(scope.row, scope.$index, tableData)"
                  :title="$t('LanguageLib.DELETE')"
                  type="text"
                  style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                  <i class="iconfont">&#xe619;</i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <router-view v-if="$route.path !== '/storemnt/mntcategory'"></router-view>
  </div>
</template>

<script>
import storeMntApi from '../../api/storeMnt'
import categoryTree from '@/components/categoryTree.vue'

export default {
  name: 'MntCategory',
  data () {
    return {
      defaultSort: {
        prop: 'CategoryMemo',
        order: 'ascending'
      }, // 默认排序
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'CategoryMemo', // 记录前一次的prop值
      ownerId: '',
      categoryOpenArr: [],
      currentClass: 'root',
      parentId: this.$commonfun.localStorage.getitem('ownerId').toUpperCase(),
      loading: false,
      currentPage: 1, // 默认显示第1页数据
      pageIndex: 1,
      pageSize: 20, // 默认每页显示20条数据
      tableData: [],
      showDisabled: false, // 是否显示已经下架的分类
      isSearch: false,
      selectedList: [],
      batchDisabled: true,
      showImportMenu: false,
      pageTotal: 0,
      searchText: '', // 搜索内容
      categoryData: [],
      sort: 'categoryMemo', // 排序字段
      sortOrder: 'asc', // 排序方式逆序：desc正序asc
      categoryTreeData: [],
      updataRouteQuery: () => {
        console.log('mnt保存状态机')
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.isSearch = this.isSearch
        newQuery.batchDisabled = this.batchDisabled
        newQuery.showDisabled = this.showDisabled
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.parentId = this.parentId
        newQuery.searchText = this.searchText
        newQuery.sort = this.sort
        newQuery.sortOrder = this.sortOrder
        newQuery.NoRefresh = true
        this.$router.push({
          path,
          query: newQuery
        })
      },
      getCategoryList (pageIndex, pageSize, sort, sortOrder, search, showDisable, parentId) {
        console.log('mnt调用列表接口')
        storeMntApi.getMntCategoryList('post', '/mnt/getMntCategoryPage', {
          pageIndex,
          pageSize,
          sort,
          sortOrder,
          search,
          showDisable,
          parentId
        })
          .then(res => {
            this.tableData = res.data.data
            this.pageTotal = res.data.total
          }).catch(err => {
            this.$commonfun.console.log(err)
          })
      }
    }
  },
  components: { categoryTree },
  created () {
    console.log('调用created')
    // 每一次路由变化or刷新都会调用created方法
    // 因此应该在created方法这里判断是保存状态机还是读取状态机
    // 如果存在fromPath,说明是从编辑页返回的
    if (this.$route.query.fromPath) {
      console.log('mnt读取状态机')
      // 接下来两行是把存储在url上的状态整个decode,再parse
      // 从而完整的读取状态机
      const query = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
      this.currentPage = query.currentPage * 1// int型的隐式转换
      this.pageSize = query.pageSize * 1
      this.parentId = query.parentId
      this.searchText = query.searchText// 因为整个都decode又parse,所以不需要再decode了
      this.sort = query.sort
      this.sortOrder = query.sortOrder
    }
    this.getCategoryTreeData()
    this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
  },
  methods: {
    getCategoryLevel (id) {
      if (id === this.ownerId) {
        return 'root'
      }
      // 在展开的数组里找,如果有,就说明是第一级
      const firstClass = this.categoryOpenArr.filter(x => x === id)

      let secondClassList = []
      this.categoryTreeData[0].childCategoryTrees.forEach(x => {
        if (x.childCategoryTrees) {
          // 说明有子树
          secondClassList = secondClassList.concat(x.childCategoryTrees)
        }
      })
      const secondClass = secondClassList.filter(x => x.id === id)

      let thirdClassList = []
      secondClassList.forEach(x => {
        if (x.childCategoryTrees) {
          // 说明有子树
          thirdClassList = thirdClassList.concat(x.childCategoryTrees)
        }
      })
      const thirdClass = thirdClassList.filter(x => x.id === id)

      if (firstClass.length !== 0) {
        return 'first'
      } else if (secondClass.length !== 0) {
        return 'second'
      } else if (thirdClass !== 0) {
        return 'third'
      }
    },
    onShowWithDrawChange (e) {
      this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
    },
    // 把维修问题列表变成字符串
    listToString (list) {
      const l = list.map(x => x.problemCategoryName)
      return l.toString()
    },

    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      // 请求列表接口数据
      this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      // 请求列表接口数据
      this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
    },
    getCategoryTreeData () {
      storeMntApi.getMntCategoryTreeData('get', '/mnt/mntcategorytree?showDisable=' + this.showDisabled)
        .then(res => {
          console.log('调用树接口')
          // 只要调用树接口,就一定要给树赋新的值
          // 不管你第几次进来,都是直接把值刷新,然后塞新的假根节点
          this.categoryData = res.data
          this.ownerId = this.$commonfun.localStorage.getitem('ownerId').toUpperCase()
          if (!this.ownerId) {
            this.ownerId = res.data[0].ownerID.toUpperCase()
          }
          this.categoryData.forEach(x => {
            x.id = x.id.toUpperCase()
            x.parentID = x.parentID.toUpperCase()
            x.ownerID = x.ownerID.toUpperCase()
          })

          const fakeRoot = {
            categoryMemo: this.$t('LanguageLib.MNT_CATEGORY'),
            parentID: '',
            categoryCode: null,
            ownerID: this.ownerId,
            id: this.ownerId
          }
          this.categoryData.unshift(fakeRoot)
          // 第一个条件?
          // 第二个条件是为了判断是不是第一次进来
          // 如果是第一次进来,触发树组件的点击事件
          // 从而触发updataRouteQuery
          if (res.data.length > 0 && this.$route.query.fromPath === undefined) {
            // 'nextTick()' 下次dom更新时触发回调函数
            // 默认点击
            console.log('第一次进来')
            this.$nextTick().then(() => {
              if (document.querySelector('.el-tree-node__content')) {
                document.querySelector('.el-tree-node__content').click()
              }
            })
          }
          // 对树数据做处理,然后赋新的值
          const ctd = this.$commonfun.toCategoryTree(res.data, 'childCategoryTrees', 'id', 'parentID')
          ctd.forEach(x => {
            x.id = x.id.toUpperCase()
            x.parentID = x.parentID.toUpperCase()
            x.ownerID = x.ownerID.toUpperCase()
          })
          this.categoryTreeData = ctd
          this.categoryOpenArr = ctd[0].childCategoryTrees.map(x => x.id)
        }
        ).catch(err => {
          this.$commonfun.console.log(err)
        })
    },

    // 删除分类
    deleteCategory (row, index, data) {
      console.log(row)
      const deleteList = []
      deleteList.push(row.id)
      this.$commonfun.confirm(this.$t('LanguageLib.IS_DELETE_CATEGORY'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeMntApi.deleteCategory('post', '/mnt/deleteMntCategory', deleteList)
            .then(res => {
              console.log(res)
              if (res.data.failCount === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                })
              } else if (res.data.successCount === 0) {
                this.$message({
                  type: 'error',
                  message: this.$t('LanguageLib.PLZ_USE_WITHDRAW')
                })
              } else {
                this.$message({
                  type: 'success',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DELETE'))
                })
              }
              this.getCategoryTreeData()
              this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 批量删除分类
    batchDeleteCategory () {
      const deleteList = this.selectedList
      this.$commonfun.confirm(this.$t('LanguageLib.IS_DELETE_CATEGORY'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeMntApi.deleteCategory('post', '/mnt/deleteMntCategory', deleteList)
            .then(res => {
              console.log('删除成功')
              console.log(res)
              if (res.data.failCount === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                })
              } else if (res.data.successCount === 0) {
                this.$message({
                  type: 'error',
                  message: this.$t('LanguageLib.PLZ_USE_WITHDRAW')
                })
              } else {
                this.$message({
                  type: 'success',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DELETE'))
                })
              }
              this.getCategoryTreeData()
              this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 批量下架
    batchWithdrawCategory () {
      const withdrawList = this.selectedList
      this.$commonfun.confirm(this.$t('LanguageLib.IS_WITHDRAW_CATEGORY'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeMntApi.deleteCategory('post', '/mnt/disableMntCategory', withdrawList)
            .then(res => {
              if (res.data.failCount === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.WITHDRAW_SUCCESSFUL')
                })
              } else {
                this.$message({
                  type: 'success',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.WITHDRAW_SHELVES'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.WITHDRAW_SHELVES'), this.$t('LanguageLib.WITHDRAW_SHELVES'))
                })
              }
              this.getCategoryTreeData()
              this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 批量上架
    batchStackCategory () {
      const stackList = this.selectedList

      storeMntApi.enableMntCategory('post', '/mnt/enableMntCategory', stackList)
        .then(res => {
          if (res.data.failCount === 0) {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.STACK_SUCCESSFUL')
            })
          } else {
            this.$message({
              type: 'success',
              message: this.$commonfun.stringFormat(this.$t('LanguageLib.STACK_SHELVES'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.STACK_SHELVES'), this.$t('LanguageLib.STACK_SHELVES'))
            })
          }
          this.getCategoryTreeData()
          this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 树组件传过来的数据-分类
    getTreeCheckDataCategory (data) {
      console.log(data)
      console.log('mnt点击树组件')
      const parentId = data.id
      this.currentClass = this.getCategoryLevel(parentId)
      if (this.currentClass === 'third') {
        this.batchDisabled = true
      }
      this.parentId = parentId
      this.updataRouteQuery()
      this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, parentId)
    },
    importExport () {
      this.showImportMenu = true
    },
    // 上架
    stackCategory () {
    },
    // 导出excel
    exportExcel () {
    },
    addCategory () {
      const x = {
        isSearch: this.isSearch,
        batchDisabled: this.batchDisabled,
        showDisabled: this.showDisabled,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        sort: this.sort,
        sortOrder: this.sortOrder,
        searchText: this.searchText,
        type: 'add',
        parentId: this.parentId,
        level: this.currentClass
      }
      this.$router.push({
        path: '/storemnt/mntcategory/editmntcategory',
        query: {
          myQuery: this.$commonfun.encodeUrl(JSON.stringify(x))
        }
      })
    },
    editCategory (row, index, data) {
      const x = {
        // 为了在页面里区分是编辑还是添加
        type: 'edit',
        // 保存状态机(列表相关的状态)
        isSearch: this.isSearch,
        batchDisabled: this.batchDisabled,
        showDisabled: this.showDisabled,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        sort: this.sort,
        sortOrder: this.sortOrder,
        searchText: this.searchText,
        // 保存树组件的状态
        parentId: this.parentId,
        level: this.currentClass,
        // OBJ里携带了id,在编辑页读取id来拿详情
        categoryObj: row
      }
      this.$router.push({
        path: '/storemnt/mntcategory/editmntcategory',
        query: {
          myQuery: this.$commonfun.encodeUrl(JSON.stringify(x))
        }
      })
    },
    downloadExcel () {
    },
    searchCategoryList () {
      this.currentPage = 1
      this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
    },
    // 清除搜索状态
    clearSearchData () {
      this.isSearch = false
      this.searchText = ''
      this.currentPage = 1
      this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
    },
    drawerOpen () {
    },
    // 选择分类
    selectionChange (selection) {
      this.selectedList = []
      console.log(selection)
      for (let i = 0; i < selection.length; i++) {
        this.selectedList.push(selection[i].id)
      }
      if (this.selectedList.length === 0) {
        this.batchDisabled = true
      } else {
        this.batchDisabled = false
      }
    },
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.sortOrder = 'asc'
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.sortOrder = 'desc'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.sortOrder = column.column.order === 'descending' ? 'desc' : 'asc'
      }
      this.sort = column.prop
      // 请求列表接口数据

      this.getCategoryList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.showDisabled, this.parentId)
    }
  }
}
</script>

<style lang="scss">
  #mntCategory {
    height: 100%;

    .left {
      background: #fff;
      float: left;
      height: 100%;
      border-right: 1px solid #f2f2f2;

      .treeBox {
        height: calc(100% - 50px);
        overflow: auto;
        width: 100%;
      }

      .fifter {
        padding: 10px 0 10px 6%;
        line-height: 30px;

        .el-input {
          width: 60%;
        }

        .el-button--text {
          margin-left: 2.5%;
          padding: 2% 0;
          width: 20%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .right {
      width: 80%;
      margin-left: 20%;
      height: 100%;

      .showWithdraw {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 14px;
        margin-right: 25px;
        display: inline-block;
      }

      .operation {
        background: #fff;
        height: 30px;
        padding: 10px 0 10px 20px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;

        .operationBtn {
          width: auto;
          display: inline-block;
          float: left;
          position: relative;

          .el-button {
            height: 30px;
            padding: 7px 20px;
          }

          .BatchSetting {
            background: #fff;
            color: #666666;
            position: absolute;
            left: 0;
            top: 30px;
            width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
            }
          }

          .exportType {
            background: #fff;
            color: #666666;
            position: absolute;
            right: 0;
            top: 30px;
            min-width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
              padding: 0 10px;
            }

            .upload {
              position: absolute;
              top: 30px;
              width: 100%;
              opacity: 0;

              .el-upload {
                width: 100%;

                button {
                  width: 100%;
                  padding-left: 0;
                }
              }
            }
          }
        }

        .operationSearch {
          float: right;
          padding-right: 51px;
          position: relative;

          .shaixuan {
            color: #999999;
            height: 15px;
            width: 15px;
            position: relative;
            top: 2px;
            margin-left: 10px;
            margin-right: 10px;
            font-weight: 600;
          }

          .shaixuan1 {
            color: #3BC6B9;
          }

          .el-input {
            width: 160px;

            .el-input__inner {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }

          .el-icon-search {
            line-height: 30px;
          }
        }
      }

      .tableParent {
        height: calc(100% - 98px);
      }

      .el-pagination {
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
    }

    .drawerTitle {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      line-height: 25px;
      margin-bottom: 20px;
    }

    .drawerText {
      height: 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      line-height: 16px;
      margin-bottom: 5px;
    }

    .el-button--primary {
      background-color: #3BC6B9;
      color: #fff;
      border: none;
      margin-left: 10px;
    }

    .el-button--primary:hover {
      background-color: #3BC6B9;
      color: #fff;
      border: none;
    }

    /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #3BC6B9 !important;
      border-color: #3BC6B9 !important;
    }*/
    // 对于树组件配置特有的css
    .el-tree-node > .el-tree-node__children {
      overflow: unset;
    }

    .el-tree-node__content {
      height: 48px;
    }

    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: #F6F6F6
    }

    // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
    //   color: #3BC6B9 !important;
    // }
    // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
    //   color: #3BC6B9 !important;
    // }
    // 更改表格的滚动条样式
    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }

    // 抽屉组件样式修改
    .el-drawer.rtl {
      outline: none;
    }

    .el-drawer__wrapper {
      top: 172px;
      bottom: 18px;
      /*  right: 20px;*/
    }

    section.el-drawer__body {
      padding: 20px;

      .el-input {
        margin-bottom: 15px;
      }
    }

    .el-drawer__container {
      outline: none;
    }

    .colorG {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(59, 198, 185, 1);
      line-height: 20px;
    }

    .el-table .descending .sort-caret.descending {
    }

    .el-table .ascending .sort-caret.ascending {
      border-bottom-color: #3BC6B9;
    }

    .el-pager li.active {
      color: #3BC6B9;
    }

    .el-table__fixed-body-wrapper .el-table__body {
      padding-bottom: 10px;
    }

    .filterContent {
      height: calc(100% - 154px);
      overflow: hidden;
      overflow-y: auto;
    }

    .filterContent::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .filterContent::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .filterContent::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }

    .el-table-column--selection {
      text-align: center !important;
    }

    .el-tooltip__popper.is-light {
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      border: 1px solid #E4E7ED !important;
      background-color: #fff;
      color: #000;

      .popper__arrow {
        border-top-color: #E4E7ED;
        border: #E4E7ED;
      }

      .popper__arrow::after {
        border-top-color: #fff;
      }
    }
  }
</style>
